export const imageCdnUrl = (image, options = {}) => {
  const optionsArr = Object.entries({ limit: 1, m: "fill", ...options });
  const query = optionsArr
    .filter(([k, v]) => !!v)
    .map(([key, value]) => `${key}_${value}`)
    .join(",");
  return `https://image.gcores.com/${image}?x-oss-process=image${
    query ? `/resize,${query}` : ""
  }/quality,q_90`;
};

export const scrollToTarget = (target) => {
  const id = target.getAttribute("href");
  const elem = id && document.querySelector(`#${id.split("#")[1]}`);

  if (!elem) {
    return false;
  }

  const headerOffset = 50;
  const elementPosition = elem.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth",
  });

  return true;
};

export function capitalizeFirstLetter(string) {
  if (!string) {
    return string;
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const convertToDate = (date) => {
  if (!date) {
    return null;
  }
  if (date instanceof Date) {
    return date;
  }
  return new Date(date);
};

export const getTimestamp = (date) => {
  const parsedDate = convertToDate(date);
  if (!parsedDate) {
    return 0;
  }

  return parsedDate.getTime() / 1000;
};

export const wxReadyEvent = (event) => {
  if (typeof window.WeixinJSBridge === "undefined") {
    document.addEventListener(
      "WeixinJSBridgeReady",
      () => {
        event();
      },
      false
    );
  } else {
    window.WeixinJSBridge.invoke(
      "getNetworkType",
      {},
      function (e) {
        event();
      },
      false
    );
  }
};
